if (!customElements.get('bestsellers-carousel')) {
  customElements.define(
    'bestsellers-carousel',
    class BestsellersCarousel extends HTMLElement {
      connectedCallback() {
        this.scroller = this.querySelector('.custom-featured-collection__scroller');
        this.prevButton = this.querySelector('[data-carousel-prev]');
        this.nextButton = this.querySelector('[data-carousel-next]');
        this.onPrevClick = this.onPrevClick.bind(this);
        this.onNextClick = this.onNextClick.bind(this);
        this.onScrollerScroll = this.onScrollerScroll.bind(this);
        this.updateArrowState = this.updateArrowState.bind(this);

        this.scroller?.addEventListener('scroll', this.onScrollerScroll, { passive: true });
        this.prevButton?.addEventListener('click', this.onPrevClick);
        this.nextButton?.addEventListener('click', this.onNextClick);
        window.addEventListener('resize', this.updateArrowState);
        this.updateArrowState();
      }

      disconnectedCallback() {
        this.scroller?.removeEventListener('scroll', this.onScrollerScroll);
        this.prevButton?.removeEventListener('click', this.onPrevClick);
        this.nextButton?.removeEventListener('click', this.onNextClick);
        window.removeEventListener('resize', this.updateArrowState);
      }

      onPrevClick() {
        this.scrollBy(-1);
      }

      onNextClick() {
        this.scrollBy(1);
      }

      onScrollerScroll() {
        this.updateArrowState();
      }

      getScrollAmount() {
        const firstItem = this.scroller?.querySelector('.bestsellers-carousel__promo, .custom-featured-collection__card');

        if (!firstItem) {
          return Math.round((this.scroller?.clientWidth || 0) * 0.85);
        }

        const list = this.scroller?.querySelector('.custom-featured-collection__product-list');
        const gap = list ? parseFloat(window.getComputedStyle(list).columnGap || '0') : 0;

        return Math.round(firstItem.getBoundingClientRect().width + gap);
      }

      scrollBy(direction) {
        if (!this.scroller) {
          return;
        }

        this.scroller.scrollBy({
          left: this.getScrollAmount() * direction,
          behavior: 'smooth',
        });
      }

      updateArrowState() {
        if (!this.prevButton || !this.nextButton || !this.scroller) {
          return;
        }

        const canScroll = this.scroller.scrollWidth > this.scroller.clientWidth + 1;
        const atStart = this.scroller.scrollLeft <= 1;
        const atEnd = this.scroller.scrollLeft + this.scroller.clientWidth >= this.scroller.scrollWidth - 1;

        this.prevButton.disabled = !canScroll || atStart;
        this.nextButton.disabled = !canScroll || atEnd;
      }
    }
  );
}
